import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  supportedSexyBodyShapes,
  supportedSexyHairColors,
} from '@/pages/Paywall/Variants/V6/constants';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { OwnAiTitle } from '../../components/Title';
import { useLayoutFormSelections } from '../../hooks/useLayoutFormSelections';

import { LonelinessGraphStyles } from './LonelinessGraph.styles';

export const ScreenLonelinessGraph: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Loneliness Graph',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const { ageGeneration, bodyShape, hairColor } = useLayoutFormSelections();

  React.useEffect(() => {
    if (webCampaign.setup.paywallImagesVariant === 'v6-sexy') {
      // TODO should be updated with link from s3
      preloadImage(
        `../assets/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
    }

    const isCrutchOnly4NsfwGirl =
      webCampaign.setup.paywallNotes.includes('4-nsfw-girl') &&
      hairColor &&
      supportedSexyHairColors.includes(hairColor) &&
      bodyShape &&
      supportedSexyBodyShapes.includes(bodyShape);

    if (isCrutchOnly4NsfwGirl) {
      // TODO should be updated with link from s3
      preloadImage(
        `../assets/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
    } else {
      preloadImage(
        `${S3_BUCKET_URL}/paywall/v6/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LonelinessGraphStyles
      background="dark-violet"
      staticTheme={webCampaign.getStaticTheme()}
    >
      <IonContent>
        <OwnAiTitle className="loneliness-graph-title">
          Feeling lonely is okay. Even if you are in the relationship
        </OwnAiTitle>

        <div className="img-container">
          <img src="" alt="preferences_image" />
        </div>

        <div className="description">
          <UiTypography variant="title-medium" color="black">
            Odds of Premature Mortality
          </UiTypography>
          <UiTypography variant="label-small" color="neutral-black">
            Source: Holt-Lunstad J, Robles TF, Sbarra DA. <br />
            Advancing Social Connection as a
          </UiTypography>
        </div>
      </IonContent>

      <OnboardingFooter buttonColor="pink" onContinue={wizard.nextStep} />
    </LonelinessGraphStyles>
  );
};
